// src/components/IndiaMapQuiz.jsx
import React, { useEffect, useMemo, useState } from "react";
import { geoCentroid } from "d3-geo";
import indiaStates from "../data/indiaStates.json";
import MapCard from "./MapCard";
import OptionsCard from "./OptionCard";

// basic state info – baad me expand kar sakte ho
const STATE_INFO = {
  "Andhra Pradesh": {
    capital: "Amaravati",
    cm: "N. Chandrababu Naidu",
    governor: "S. Abdul Nazeer",
    neighbours: "Chhattisgarh, Odisha, Telangana, Karnataka, Tamil Nadu",
  },
  "Arunachal Pradesh": {
    capital: "Itanagar",
    cm: "Pema Khandu",
    governor: "Lt. Gen K.T. Parnaik",
    neighbours: "Assam, Nagaland, Bhutan, Myanmar, China",
  },
  Assam: {
    capital: "Dispur",
    cm: "Himanta Biswa Sarma",
    governor: "Lakshman Acharya",
    neighbours:
      "Arunachal Pradesh, Nagaland, Manipur, Mizoram, Tripura, Meghalaya, West Bengal, Bhutan, Bangladesh",
  },
  Bihar: {
    capital: "Patna",
    cm: "Nitish Kumar",
    governor: "Rajendra Arlekar",
    neighbours: "Uttar Pradesh, Jharkhand, West Bengal, Nepal",
  },
  Chhattisgarh: {
    capital: "Raipur",
    cm: "Vishnu Deo Sai",
    governor: "Ramen Deka",
    neighbours:
      "Uttar Pradesh, Jharkhand, Odisha, Andhra Pradesh, Telangana, Maharashtra, Madhya Pradesh",
  },
  Goa: {
    capital: "Panaji",
    cm: "Pramod Sawant",
    governor: "P. S. Sreedharan Pillai",
    neighbours: "Maharashtra, Karnataka",
  },
  Gujarat: {
    capital: "Gandhinagar",
    cm: "Bhupendra Patel",
    governor: "Acharya Devvrat",
    neighbours: "Rajasthan, Madhya Pradesh, Maharashtra",
  },
  Haryana: {
    capital: "Chandigarh",
    cm: "Nayab Singh Saini",
    governor: "Bandaru Dattatreya",
    neighbours: "Punjab, Himachal Pradesh, Rajasthan, Uttar Pradesh, Delhi",
  },
  "Himachal Pradesh": {
    capital: "Shimla",
    cm: "Sukhvinder Singh Sukhu",
    governor: "Shiv Pratap Shukla",
    neighbours: "Jammu & Kashmir (UT), Ladakh (UT), Punjab, Haryana, Uttarakhand, China",
  },
  Jharkhand: {
    capital: "Ranchi",
    cm: "Hemant Soren",
    governor: "Santosh Kumar Gangwar",
    neighbours: "Bihar, West Bengal, Odisha, Chhattisgarh, Uttar Pradesh",
  },
  Karnataka: {
    capital: "Bengaluru",
    cm: "Siddaramaiah",
    governor: "Thaawarchand Gehlot",
    neighbours:
      "Goa, Maharashtra, Telangana, Andhra Pradesh, Tamil Nadu, Kerala",
  },
  Kerala: {
    capital: "Thiruvananthapuram",
    cm: "Pinarayi Vijayan",
    governor: "Arif Mohammed Khan",
    neighbours: "Tamil Nadu, Karnataka",
  },
  "Madhya Pradesh": {
    capital: "Bhopal",
    cm: "Mohan Yadav",
    governor: "Mangubhai C. Patel",
    neighbours:
      "Uttar Pradesh, Chhattisgarh, Maharashtra, Gujarat, Rajasthan",
  },
  Maharashtra: {
    capital: "Mumbai",
    cm: "Devendra Fadnavis",
    governor: "C. P. Radhakrishnan",
    neighbours:
      "Gujarat, Madhya Pradesh, Chhattisgarh, Telangana, Karnataka, Goa",
  },
  Manipur: {
    capital: "Imphal",
    cm: "N. Biren Singh",
    governor: "Anusuiya Uikey",
    neighbours: "Nagaland, Assam, Mizoram, Myanmar",
  },
  Meghalaya: {
    capital: "Shillong",
    cm: "Conrad Sangma",
    governor: "C. H. Vijayashankar",
    neighbours: "Assam, Bangladesh",
  },
  Mizoram: {
    capital: "Aizawl",
    cm: "Lalduhoma",
    governor: "Gen V. K. Singh (Retd.)",
    neighbours: "Tripura, Assam, Manipur, Bangladesh, Myanmar",
  },
  Nagaland: {
    capital: "Kohima",
    cm: "Neiphiu Rio",
    governor: "La. Ganesan",
    neighbours: "Arunachal Pradesh, Assam, Manipur, Myanmar",
  },
  Odisha: {
    capital: "Bhubaneswar",
    cm: "Mohan Charan Majhi",
    governor: "Hari Babu Kambhampati",
    neighbours: "West Bengal, Jharkhand, Chhattisgarh, Andhra Pradesh",
  },
  Punjab: {
    capital: "Chandigarh",
    cm: "Bhagwant Mann",
    governor: "Gulab Chand Kataria",
    neighbours: "Jammu & Kashmir (UT), Himachal Pradesh, Haryana, Rajasthan, Pakistan",
  },
  Rajasthan: {
    capital: "Jaipur",
    cm: "Bhajan Lal Sharma",
    governor: "Haribhau Kisanrao Bagde",
    neighbours:
      "Punjab, Haryana, Uttar Pradesh, Madhya Pradesh, Gujarat",
  },
  Sikkim: {
    capital: "Gangtok",
    cm: "Prem Singh Tamang",
    governor: "Om Prakash Mathur",
    neighbours: "West Bengal, Nepal, China, Bhutan",
  },
  "Tamil Nadu": {
    capital: "Chennai",
    cm: "M. K. Stalin",
    governor: "R. N. Ravi",
    neighbours:
      "Kerala, Karnataka, Andhra Pradesh, Puducherry (UT)",
  },
  Telangana: {
    capital: "Hyderabad",
    cm: "Revanth Reddy",
    governor: "Jishnu Dev Varma",
    neighbours:
      "Maharashtra, Chhattisgarh, Andhra Pradesh, Karnataka",
  },
  Tripura: {
    capital: "Agartala",
    cm: "Manik Saha",
    governor: "Indrasena Reddy Nallu",
    neighbours: "Assam, Mizoram, Bangladesh",
  },
  "Uttar Pradesh": {
    capital: "Lucknow",
    cm: "Yogi Adityanath",
    governor: "Anandiben Patel",
    neighbours:
      "Uttarakhand, Himachal Pradesh, Haryana, Delhi, Rajasthan, Madhya Pradesh, Chhattisgarh, Jharkhand, Bihar",
  },
  Uttarakhand: {
    capital: "Dehradun",
    cm: "Pushkar Singh Dhami",
    governor: "Gurmit Singh",
    neighbours: "Himachal Pradesh, Uttar Pradesh, China, Nepal",
  },
  "West Bengal": {
    capital: "Kolkata",
    cm: "Mamata Banerjee",
    governor: "C. V. Ananda Bose",
    neighbours:
      "Odisha, Jharkhand, Bihar, Sikkim, Assam, Bangladesh, Nepal, Bhutan",
  },
};

function shuffleArray(arr) {
  return [...arr].sort(() => Math.random() - 0.5);
}

function distanceSq(a, b) {
  if (!a || !b) return Number.MAX_VALUE;
  const dx = a[0] - b[0];
  const dy = a[1] - b[1];
  return dx * dx + dy * dy;
}

export default function IndiaMapQuiz({ moreInfoEnabled }) {
  const [currentState, setCurrentState] = useState(null);
  const [correctLabel, setCorrectLabel] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);

  // score value ko use nahi karna, sirf setter
  const [, setScore] = useState(0);
  const [questionNumber, setQuestionNumber] = useState(1);

  const [vw, setVw] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const h = () => setVw(window.innerWidth);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const isMobile = vw <= 768;
  const mapScale = isMobile ? 850 : 650;

  const allStates = useMemo(() => {
    if (!indiaStates?.features) return [];
    return indiaStates.features
      .map((f, i) => {
        const p = f.properties || {};
        const name =
          p.State_Name ||
          p.STATE_NAME ||
          p.NAME_1 ||
          p.ST_NM ||
          p.name ||
          p.st_nm;
        if (!name) return null;
        let center = null;
        try {
          center = geoCentroid(f);
        } catch {
          center = null;
        }
        return {
          id: f.id || p.ID || p.STATE_CODE || p.ST_CODE || i,
          name,
          feature: f,
          center,
        };
      })
      .filter(Boolean);
  }, []);

  const generateQuestion = () => {
    if (allStates.length < 4) return;

    const correct =
      allStates[Math.floor(Math.random() * allStates.length)];
    const others = allStates.filter((s) => s.name !== correct.name);

    const neighbours = others
      .map((s) => ({ ...s, _d: distanceSq(correct.center, s.center) }))
      .sort((a, b) => a._d - b._d)
      .slice(0, 3);

    const opts = shuffleArray([
      correct.name,
      ...neighbours.map((n) => n.name),
    ]);

    setCurrentState(correct);
    setCorrectLabel(correct.name);
    setOptions(opts);
    setSelectedAnswer(null);
    setIsCorrect(null);
  };

  useEffect(() => {
    if (!allStates.length) return;
    generateQuestion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allStates.length]);

  const loading = !currentState || !options.length;

  const goNext = () => {
    setQuestionNumber((q) => q + 1);
    generateQuestion();
  };

  const handleAnswer = (answer) => {
    if (!correctLabel || selectedAnswer) return;

    setSelectedAnswer(answer);
    const ok = answer === correctLabel;
    setIsCorrect(ok);
    if (ok) setScore((s) => s + 1);

    // Yahan auto-next nahi hai – user Next dabayega
  };

  const stateInfo =
    correctLabel && STATE_INFO[correctLabel]
      ? STATE_INFO[correctLabel]
      : null;

  return (
    <div className="quiz-body">
      <MapCard
        geojson={indiaStates}
        currentState={currentState}
        questionNumber={questionNumber}
        loading={loading}
        mapScale={mapScale}
      />

      <OptionsCard
        mode="india"
        options={options}
        correctLabel={correctLabel}
        selectedAnswer={selectedAnswer}
        isCorrect={isCorrect}
        loading={loading}
        onAnswer={handleAnswer}
        onNext={goNext}
        moreInfoEnabled={moreInfoEnabled}
        stateInfo={stateInfo}
      />
    </div>
  );
}
